import { action, Action, computed, Computed } from 'easy-peasy'

export interface UIModel {
  tableTop: number // getBoundingClientRect().top
  tableBottom: number // getBoundingClientRect().bottom
  tableTopPastViewport: Computed<UIModel, boolean>
  tableCompletelyAboveViewport: Computed<UIModel, boolean>
  setTableRect: Action<UIModel, Partial<DOMRect>>
}

const ui: UIModel = {
  tableTop: 0,
  tableBottom: 0,

  tableTopPastViewport: computed(state => {
    return state.tableTop < 0
  }),

  tableCompletelyAboveViewport: computed(state => {
    return state.tableBottom < 0
  }),

  setTableRect: action((state, rect) => {
    state.tableTop = rect.top || 0
    state.tableBottom = rect.bottom || 0
  }),
}

export default ui
